export const countLines = (content: string): number => {
  const trimmedContent = content.trimEnd();
  return trimmedContent ? trimmedContent.split(/\r\n|\r|\n/).length : 0;
};

export const formatLineCount = (content: string): string => {
  const lineCount = countLines(content);
  return `${lineCount} ${lineCount === 1 ? 'line' : 'lines'}`;
};
